import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }: { children: React.ReactElement }) {
	const token = localStorage.getItem("token");

	// Считаем валидным токен, если он реально есть и не равен "undefined" или "null"
	if (!token || token === "undefined" || token === "null") {
		localStorage.removeItem("token");
		return <Navigate to="/login" replace />;
	}

	return children;
}